import { motion } from "framer-motion";
import { BadgePercent, ArrowRight } from "lucide-react";

const Checker = () => (
  <div className="hidden md:grid grid-cols-2 gap-1 w-14 shrink-0" aria-hidden="true">
    {[0, 1, 2, 3, 4, 5].map((i) => (
      <span
        key={i}
        className={`w-6 h-6 rounded-[2px] ${i % 3 === 1 ? "bg-[#0066FF]" : i % 3 === 2 ? "bg-white" : "bg-[#F59E0B]"}`}
      />
    ))}
  </div>
);

export const PromoBanner = ({ onNavigate }) => (
  <section data-testid="promo-section" className="relative overflow-hidden border-y border-[#F59E0B]/30 bg-gradient-to-r from-[#F59E0B]/15 via-[#0A0D16] to-[#0A0D16]">
    <div className="max-w-7xl mx-auto px-6 lg:px-10 py-12 md:py-16 flex flex-col md:flex-row items-center gap-8 md:gap-12">
      <Checker />

      <motion.div
        initial={{ opacity: 0, scale: 0.9 }}
        whileInView={{ opacity: 1, scale: 1 }}
        viewport={{ once: true, margin: "-60px" }}
        transition={{ duration: 0.6, ease: [0.16, 1, 0.3, 1] }}
        className="shrink-0"
      >
        <div className="font-display font-extrabold tracking-tighter text-6xl md:text-7xl text-[#F59E0B] leading-none">
          -200€
        </div>
      </motion.div>

      <motion.div
        initial={{ opacity: 0, y: 24 }}
        whileInView={{ opacity: 1, y: 0 }}
        viewport={{ once: true, margin: "-60px" }}
        transition={{ duration: 0.6, delay: 0.1 }}
        className="flex-1 text-center md:text-left"
      >
        <div className="font-mono-tech text-xs uppercase tracking-[0.3em] text-[#F59E0B] flex items-center justify-center md:justify-start gap-2">
          <BadgePercent className="w-4 h-4" />
          Offre du moment
        </div>
        <h3 className="font-display font-bold text-2xl md:text-3xl tracking-tight mt-3">
          Pare-brise remplacé, 200€ offerts
        </h3>
        <p className="text-sm md:text-base text-slate-300 mt-3 leading-relaxed max-w-xl">
          Pour tout changement de pare-brise dans notre atelier de Bellignat, nous vous offrons
          200€. Impact, fissure ou éclat : ne roulez pas avec une visibilité réduite.
        </p>
        <p className="text-xs text-slate-500 mt-2">Offre du moment, conditions disponibles en atelier.</p>
      </motion.div>

      <motion.button
        data-testid="promo-section-cta"
        onClick={() => onNavigate("#contact")}
        initial={{ opacity: 0, y: 24 }}
        whileInView={{ opacity: 1, y: 0 }}
        viewport={{ once: true, margin: "-60px" }}
        transition={{ duration: 0.6, delay: 0.2 }}
        className="group shrink-0 rounded-full bg-[#F59E0B] hover:bg-[#D97706] text-[#07090E] font-bold px-7 py-3.5 flex items-center gap-2 transition-[background-color,box-shadow,transform] duration-300 hover:shadow-[0_0_32px_rgba(245,158,11,0.45)] hover:-translate-y-0.5"
      >
        J'en profite
        <ArrowRight className="w-4 h-4 transition-transform duration-300 group-hover:translate-x-1" />
      </motion.button>
    </div>
  </section>
);
